import React from "react";

export const LazyFeedPresetGroupSelectorBridge = React.lazy(
    () =>
        import(
            /* webpackChunkName: "FormControls" */ "./FeedPresetGroupSelector"
        )
);
